/**
 * Single source of truth for the OPTIMISTIC nav auth CTA.
 *
 * Every nav surface (top banner, hero nav, sticky nav, mobile burger) must
 * paint the signed-out call to action on first render and only swap to the
 * signed-in "Dashboard" CTA once Clerk has both loaded AND confirmed the
 * visitor is signed in. Centralising the rule here keeps all surfaces in
 * lockstep and makes the contract trivially testable without mounting Clerk.
 *
 * @param isLoaded   `useAuth().isLoaded` - false until clerk-js resolves.
 * @param isSignedIn `useAuth().isSignedIn` - undefined/false until resolved.
 * @returns `true` only when auth is loaded and the user is confirmed signed in.
 *          Defaults to `false` (signed-out CTA) during the load window so a hard
 *          refresh never blanks the CTA nor waits on the auth fetch.
 */
export function showDashboardCta(
  isLoaded: boolean | undefined,
  isSignedIn: boolean | undefined,
): boolean {
  return Boolean(isLoaded) && Boolean(isSignedIn)
}
